import { IS_DEV_MODE, IS_OVERRIDE_MODE } from '@/constants';

export const modeBanner = () => {
  if (!(IS_OVERRIDE_MODE || IS_DEV_MODE)) return;

  const header = document.querySelector('header');
  const p = document.createElement('p');
  p.className = 'ebizio-banner';

  if (IS_OVERRIDE_MODE) {
    p.classList.add('ebizio-banner--override-mode');
    p.innerHTML = 'ITS SERVICES OVERRIDE MODE';
  } else if (IS_DEV_MODE) {
    p.classList.add('ebizio-banner--dev-mode');
    p.innerHTML = 'ITS SERVICES DEV MODE';
  }

  const style = document.createElement('style');
  style.innerText = `
  .ebizio-banner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    text-align: center;
    margin: 0;
    z-index: 9999;
    font-weight: bold;
  }

  .ebizio-banner--dev-mode {
    background-color: crimson;
    color: white;
  }

  .ebizio-banner--override-mode {
    background-color: goldenrod;
    color: white;
  }
  `;

  p.append(style);

  header?.prepend(p);
};
